interface ProductImage {
  id: number;
  image: string;
}

interface ProductGalleryProps {
  productImages: ProductImage[];
  productDemoImages: ProductImage[];
}

export default function ProductGallery({
  productImages,
  productDemoImages,
}: ProductGalleryProps) {
  return (
    <div className="grid grid-cols-2 gap-8">
      {/* Product Images */}
      <GalleryCard title="Product Images" images={productImages} />

      {/* Demo Images */}
      <GalleryCard title="Profile Images" images={productDemoImages} />
    </div>
  );
}

interface GalleryCardProps {
  title: string;
  images: ProductImage[];
}

function GalleryCard({ title, images }: GalleryCardProps) {
  return (
    <div className="rounded-3xl bg-white p-8 shadow-sm">
      {/* Header */}
      <div className="mb-6 flex items-center justify-between border-b border-gray-100 pb-5">
        <h2 className="text-2xl font-bold text-gray-900">{title}</h2>

        <span
          className="rounded-full
                    bg-slate-100
                    text-slate-700
                    px-3
                    py-1
                    text-xs
                    font-semibold">
          {images.length} Image{images.length !== 1 ? "s" : ""}
        </span>
      </div>

      {/* Images */}
      {images.length === 0 ? (
        <div className="flex h-56 items-center justify-center rounded-2xl border-2 border-dashed border-gray-300 text-gray-400">
          No Image
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-4">
          {images.map((item) => (
            <div
              key={item.id}
              className="overflow-hidden rounded-2xl border border-gray-200">
              <img
                src={item.image}
                alt={title}
                className="h-40 w-full cursor-pointer object-cover transition duration-300 hover:scale-105"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
